// extracted by mini-css-extract-plugin
export default {"form":"V7YtAld","applyButton":"NP72FFi"};